import { useQuery } from "@tanstack/react-query";
import { useDispatch } from "react-redux";
import { setWorkOrderDetail } from "../store/workOrder/workOrderSlice";
import { useParams } from "react-router-dom";
import {
  fetchJobDetail,
  fetchUserAllowedAction,
  fetchWorkOrderPaymetDetails,
} from "../services/api/workOrder";
import React from "react";
import useAuth from "./useAuth";
import { isVendorTech } from "../utils/helpers";

export function useUpdateWorkOrder() {
  const { id } = useParams();
  const { auth } = useAuth();
  const dispatch = useDispatch();

  const {
    isLoading: isAllowedActionLoading,
    error: isAllowedActionError,
    data: userAllowedActionData,
    refetch: refetchUserAllowedAction,
  } = useQuery({
    queryKey: ["fetchUserAllowedAction", id, auth?.user?.id],
    queryFn: () => fetchUserAllowedAction(id),
    staleTime: 0,
    cacheTime: 0,
  });

  const {
    isLoading,
    error,
    data: jobDetailData,
    refetch: updateWorkOrder,
  } = useQuery({
    queryKey: ["jobDetail"],
    queryFn: () => fetchJobDetail(id),
    enabled: !!id,
  });

  const {
    // isLoading,
    // error,
    data: workOrderPaymentData,
    refetch: refetchWorkOrderPaymetDetails,
  } = useQuery({
    queryKey: ["workOrderPayment"],
    queryFn: () => fetchWorkOrderPaymetDetails(id),
    // A vendor tech has no payment on a work order, so the call is never made.
    enabled: !!id && !isVendorTech(auth?.user),
  });

  // Dispatch work order details to the store when `jobDetailData` changes
  React.useEffect(() => {
    if (jobDetailData?.data) {
      dispatch(setWorkOrderDetail(jobDetailData?.data));
    }
  }, [jobDetailData, dispatch]);

  return {
    isLoading,
    error,
    jobDetailData,
    updateWorkOrder,
    refetchUserAllowedAction,
    refetchWorkOrderPaymetDetails,
  }; // Return `updateWorkOrder` for external call
}
